import { render, staticRenderFns } from "./OrderNewAccount.vue?vue&type=template&id=68d6c650&scoped=true&lang=pug"
import script from "./OrderNewAccount.vue?vue&type=script&lang=js"
export * from "./OrderNewAccount.vue?vue&type=script&lang=js"
import style0 from "./OrderNewAccount.vue?vue&type=style&index=0&id=68d6c650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6c650",
  null
  
)

export default component.exports